import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Listas } from 'src/app/models/generic/Listas';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { Producto } from '../../models/generic/Producto';
import { ProductosService } from '../../services/productos.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { Constantes } from '../../models/modules/Constantes';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmAfiliacionComponent } from '../confirm-afiliacion/confirm-afiliacion.component';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { RegistroAfiliado } from 'src/app/models/generic/RegistroAfiliado';
import { Cliente } from 'src/app/models/generic/Cliente';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { GestionAfiliadoService } from '../../services/gestionafiliado.service';
import { GestionAfiliado } from '../../models/generic/GestionAfiliado';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AutenticacionService } from '../../services/autenticacion.service';
import { GenerarConsultasDTO } from 'src/app/models/generic/GenerarConsultasDTO';
import { GenerarConsultasService } from 'src/app/services/generarconsultas.service';
import { Maestro_ConsultasParametros } from 'src/app/models/generic/Maestro_ConsultasParametros';
import { Maestros_ConsultasService } from '../../services/maestros_consultas.service';
import { GenerarConsultasParametrosDTO } from 'src/app/models/generic/GenerarConsultasParametrosDTO';
import { GenerarConsultasEjecucionDTO } from 'src/app/models/generic/GenerarConsultasEjecucionDTO';
import { GenerarConsultasParametrosEjecucionDTO } from 'src/app/models/generic/GenerarConsultasParametrosEjecucionDTO';
import { GenerarConsultasRetornoEjecucionDTO } from 'src/app/models/generic/GenerarConsultasRetornoEjecucionDTO';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { GenerarConsultasColumnasDTO } from 'src/app/models/generic/GenerarConsultasColumnasDTO';
import { GenerarConsultasExportarDTO } from 'src/app/models/generic/GenerarConsultasExportarDTO';

@Component({
  selector: 'generarconsultas-ejecutar',
  templateUrl: './generarconsultas-ejecutar.component.html',
  styleUrls: ['./generarconsultas-ejecutar.component.scss']
})
export class GenerarConsultasEjecutarComponent implements OnInit{
  
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<any>;
  columnasEncabezado: string[] = [];
  columnasEncabezadoDefinicion: GenerarConsultasColumnasDTO[] = [];
  listaDatos: any[] = [];
  parametrosPrincipal: GenerarConsultasDTO = new GenerarConsultasDTO();
  listParametrosFiltro: Maestro_ConsultasParametros[] = [];
  listParametrosPrincipal: GenerarConsultasParametrosDTO[] = [];
  listParametrosSecundario: GenerarConsultasParametrosDTO[] = [];
  mostrarResultadoConsulta: boolean = false;
  listaComboSINO: Maestro_EstadoActualizar[] = [];
  valorTotal: FormControl = new FormControl(0);
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public generarConsultasService: GenerarConsultasService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.IniciarFormulario();

    this.listaComboSINO = [];

    this.listaComboSINO.push({ seleccionado: true, descripcion: 'Si' });
    this.listaComboSINO.push({ seleccionado: false, descripcion: 'No' });
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
    this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);
    this.valorTotal.disable();

    this.ConsultarParametrosConsulta();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      filtro: ['']
    });
  }
  ConsultarParametrosConsulta() {
    this.mostrarCargando = true;
    this.generarConsultasService.Parametros_Consultar(this.parametrosPrincipal.id)
              .subscribe((resp: Maestro_ConsultasParametros[]) =>{
                this.mostrarCargando = false;
                this.listParametrosFiltro = resp;
                this.CrearControlesParametros();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  CrearControlesParametros() {
    this.listParametrosPrincipal = [];
    this.listParametrosSecundario = [];
    
    let listaPrincipal = this.listParametrosFiltro.filter(x => x.filtroPrincipal && x.mostrarParametro);
    for (let index = 0; index < listaPrincipal.length; index++) {

      let parametroAsignar: GenerarConsultasParametrosDTO = new GenerarConsultasParametrosDTO();
      parametroAsignar.parametro = listaPrincipal[index];
      if (listaPrincipal[index].tipoParametro === 'TEXTO') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaPrincipal[index].tipoParametro, listaPrincipal[index].valorDefecto), listaPrincipal[index].requerido);
      } else if (listaPrincipal[index].tipoParametro === 'NUMERO' || listaPrincipal[index].tipoParametro === 'ENTERO') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaPrincipal[index].tipoParametro, listaPrincipal[index].valorDefecto), listaPrincipal[index].requerido);
      } else if (listaPrincipal[index].tipoParametro === 'FECHA') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaPrincipal[index].tipoParametro, listaPrincipal[index].valorDefecto), listaPrincipal[index].requerido);
      } else if (listaPrincipal[index].tipoParametro === 'LOGICO') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaPrincipal[index].tipoParametro, listaPrincipal[index].valorDefecto), listaPrincipal[index].requerido);
      } else if (listaPrincipal[index].tipoParametro === 'LISTA') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaPrincipal[index].tipoParametro, listaPrincipal[index].valorDefecto), listaPrincipal[index].requerido);
        parametroAsignar.valoresSeleccion = this.utilitariosService.TransformarTextoALista(listaPrincipal[index].valoresPosibles);
      }

      if (this.utilitariosService.VerificarContieneDatos(parametroAsignar.control)) {
        this.listParametrosPrincipal.push(parametroAsignar);
        this.form.addControl(parametroAsignar.parametro.nombreParametro, parametroAsignar.control);
      }
    }

    let listaSecundario = this.listParametrosFiltro.filter(x => x.filtroPrincipal === false && x.mostrarParametro);
    for (let index = 0; index < listaSecundario.length; index++) {

      let parametroAsignar: GenerarConsultasParametrosDTO = new GenerarConsultasParametrosDTO();
      parametroAsignar.parametro = listaSecundario[index];
      if (listaSecundario[index].tipoParametro === 'TEXTO') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaSecundario[index].tipoParametro, listaSecundario[index].valorDefecto), listaSecundario[index].requerido);
      } else if (listaSecundario[index].tipoParametro === 'NUMERO' || listaSecundario[index].tipoParametro === 'ENTERO') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaSecundario[index].tipoParametro, listaSecundario[index].valorDefecto), listaSecundario[index].requerido);
      } else if (listaSecundario[index].tipoParametro === 'FECHA') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaSecundario[index].tipoParametro, listaSecundario[index].valorDefecto), listaSecundario[index].requerido);
      } else if (listaSecundario[index].tipoParametro === 'LOGICO') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaSecundario[index].tipoParametro, listaSecundario[index].valorDefecto), listaSecundario[index].requerido);
      } else if (listaSecundario[index].tipoParametro === 'LISTA') {
        parametroAsignar.control = this.CrearControlValidacion(this.ObtenerTipoDatoDefecto(listaSecundario[index].tipoParametro, listaSecundario[index].valorDefecto), listaSecundario[index].requerido);
        parametroAsignar.valoresSeleccion = this.utilitariosService.TransformarTextoALista(listaSecundario[index].valoresPosibles);
      }

      if (this.utilitariosService.VerificarContieneDatos(parametroAsignar.control)) {
        this.listParametrosSecundario.push(parametroAsignar);
        this.form.addControl(parametroAsignar.parametro.nombreParametro, parametroAsignar.control);
      }
    }

    if (this.listParametrosFiltro.filter(x => x.mostrarParametro).length === 0) {
      this.ConsultarInformacion();
    }
  }
  CrearControlValidacion(tipoParametro: any, requerido: boolean): FormControl {
    if (requerido) {
      return new FormControl(tipoParametro, [Validators.required]);
    }
    return new FormControl(tipoParametro);
  }
  ObtenerTipoDatoDefecto(tipoParametro: string, valorDefecto: string): any {
    let valorRetorno: any;
    if (tipoParametro === 'TEXTO' || tipoParametro === 'LISTA') {
      if (this.utilitariosService.VerificarContieneDatosTexto(valorDefecto)) {
        valorRetorno = valorDefecto;
      } else {
        valorRetorno = '';
      }
    } else if (tipoParametro === 'NUMERO' || tipoParametro === 'ENTERO') {
      if (this.utilitariosService.VerificarContieneDatosTexto(valorDefecto)) {
        if (Number(valorDefecto)) {
          valorRetorno = +valorDefecto;
        } else {
          valorRetorno = 0;
        }
      } else {
        valorRetorno = 0;
      }
    } else if (tipoParametro === 'FECHA') {
      let valorFecha: Date = this.utilitariosService.ObtenerFechaSinHora(new Date());
      if (valorDefecto !== 'HOY') {
        if (Number(valorDefecto)) {
          valorFecha = this.utilitariosService.AdicionarDiasFecha(valorFecha, +valorDefecto);
        }
      }
      valorRetorno = valorFecha;
    } else if (tipoParametro === 'LOGICO') {
      if (this.utilitariosService.VerificarContieneDatosTexto(valorDefecto)) {
        if (valorDefecto.toLocaleLowerCase() === '1' || valorDefecto.toLocaleLowerCase() === 'si' || valorDefecto.toLocaleLowerCase() === 'true') {
          valorRetorno = true;
        } else {
          valorRetorno = false;
        }
      } else {
        valorRetorno = false;
      }
    }
    return valorRetorno;
  }
  RetornarValoresParametros(): GenerarConsultasParametrosEjecucionDTO[] {
    let listaParametros: GenerarConsultasParametrosEjecucionDTO[] = [];

    let listaParametrosNoVisibles = this.listParametrosFiltro.filter(x => x.mostrarParametro === false && this.utilitariosService.VerificarContieneDatos(x.valorDefecto));
    for (let index = 0; index < listaParametrosNoVisibles.length; index++) {
      let parametroEnvio: GenerarConsultasParametrosEjecucionDTO = new GenerarConsultasParametrosEjecucionDTO();
        parametroEnvio.nombreParametro = listaParametrosNoVisibles[index].nombreParametro;
        parametroEnvio.tipoParametro = listaParametrosNoVisibles[index].tipoParametro;
        parametroEnvio.valorParametro = listaParametrosNoVisibles[index].valorDefecto;

        if (listaParametrosNoVisibles[index].valorDefecto === 'USUARIO') {
          parametroEnvio.valorParametro = this.autenticacionService.UsuarioActivo.usuario;
        } else if (listaParametrosNoVisibles[index].valorDefecto === 'HOY') {
          parametroEnvio.valorParametro = this.utilitariosService.ObtenerFechaTextoSinHora(this.utilitariosService.ObtenerFechaSinHora(new Date()));
        }

        listaParametros.push(parametroEnvio);
    }

    if (this.utilitariosService.VerificarContieneDatos(this.listParametrosPrincipal)) {
      for (let index = 0; index < this.listParametrosPrincipal.length; index++) {
        let parametroEnvio: GenerarConsultasParametrosEjecucionDTO = new GenerarConsultasParametrosEjecucionDTO();
        parametroEnvio.nombreParametro = this.listParametrosPrincipal[index].parametro.nombreParametro;
        parametroEnvio.tipoParametro = this.listParametrosPrincipal[index].parametro.tipoParametro;
        if (this.utilitariosService.VerificarContieneDatos(this.form.get(this.listParametrosPrincipal[index].parametro.nombreParametro).value)) {
          if (this.listParametrosPrincipal[index].parametro.tipoParametro === 'FECHA') {
            parametroEnvio.valorParametro = this.utilitariosService.ObtenerFechaTextoSinHora(this.form.get(this.listParametrosPrincipal[index].parametro.nombreParametro).value);
          } else if (this.listParametrosPrincipal[index].parametro.tipoParametro === 'LOGICO') {
            if (this.form.get(this.listParametrosPrincipal[index].parametro.nombreParametro).value) {
              parametroEnvio.valorParametro = 'true';
            } else {
              parametroEnvio.valorParametro = 'false';
            }
          } else if (this.listParametrosPrincipal[index].parametro.tipoParametro === 'NUMERO') {
            parametroEnvio.valorParametro = this.form.get(this.listParametrosPrincipal[index].parametro.nombreParametro).value.toString();
          } else {
            parametroEnvio.valorParametro = this.form.get(this.listParametrosPrincipal[index].parametro.nombreParametro).value;
          }
        }

        listaParametros.push(parametroEnvio);
      }
    }
    if (this.utilitariosService.VerificarContieneDatos(this.listParametrosSecundario)) {
      for (let index = 0; index < this.listParametrosSecundario.length; index++) {
        let parametroEnvio: GenerarConsultasParametrosEjecucionDTO = new GenerarConsultasParametrosEjecucionDTO();
        parametroEnvio.nombreParametro = this.listParametrosSecundario[index].parametro.nombreParametro;
        parametroEnvio.tipoParametro = this.listParametrosSecundario[index].parametro.tipoParametro;

        if (this.utilitariosService.VerificarContieneDatos(this.form.get(this.listParametrosSecundario[index].parametro.nombreParametro).value)) {
          if (this.listParametrosSecundario[index].parametro.tipoParametro === 'FECHA') {
            parametroEnvio.valorParametro = this.utilitariosService.ObtenerFechaTextoSinHora(this.form.get(this.listParametrosSecundario[index].parametro.nombreParametro).value);
          } else if (this.listParametrosSecundario[index].parametro.tipoParametro === 'LOGICO') {
            if (this.form.get(this.listParametrosSecundario[index].parametro.nombreParametro).value) {
              parametroEnvio.valorParametro = 'true';
            } else {
              parametroEnvio.valorParametro = 'false';
            }
          } else if (this.listParametrosSecundario[index].parametro.tipoParametro === 'NUMERO') {
            parametroEnvio.valorParametro = this.form.get(this.listParametrosSecundario[index].parametro.nombreParametro).value.toString();
          } else {
            parametroEnvio.valorParametro = this.form.get(this.listParametrosSecundario[index].parametro.nombreParametro).value;
          }
        }

        listaParametros.push(parametroEnvio);
      }
    }

    return listaParametros;
  }
  ConsultarInformacion() {
    if (this.form.valid) {
      let parametrosConsulta: GenerarConsultasEjecucionDTO = new GenerarConsultasEjecucionDTO();
      parametrosConsulta.id = this.parametrosPrincipal.id;
      parametrosConsulta.nombreConsulta = this.parametrosPrincipal.nombreConsulta;
      parametrosConsulta.listaParametros = this.RetornarValoresParametros();

      this.mostrarCargando = true;
      this.generarConsultasService.Ejecutar(parametrosConsulta)
                .subscribe((resp: GenerarConsultasRetornoEjecucionDTO) =>{
                  this.mostrarCargando = false;
                  this.columnasEncabezadoDefinicion = resp.listaColumnas;
                  this.columnasEncabezado = [];

                  for (let index = 0; index < this.columnasEncabezadoDefinicion.length; index++) {
                    this.columnasEncabezado.push(this.columnasEncabezadoDefinicion[index].columna);
                  }

                  this.listaDatos = JSON.parse(resp.datos);
                  this.valorTotal.setValue(resp.valorTotal);

                  this.recargarLista();
                  this.mostrarResultadoConsulta = true;
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('GenerarConsultasComponent');
  }
  recargarLista() {
    this.dataSource = new MatTableDataSource(this.listaDatos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  verificarRequeridos(listaRequeridos: GenerarConsultasParametrosDTO[]): boolean {
    let puedeContinuar: boolean = true;
    for (let index = 0; index < listaRequeridos.length; index++) {
      if (!listaRequeridos[index].control.valid) {
        puedeContinuar = false;
        break;
      }
    }
    return puedeContinuar;
  }
  VerificarColumnaFormatoEspecial(columna: string, dato: any): any {
    let columnasFormatoEspecial = this.columnasEncabezadoDefinicion.filter(x => x.columna === columna);
    if(columnasFormatoEspecial.length > 0) {
      if (columnasFormatoEspecial[0].tipoDato === 'FECHA') {
        return this.utilitariosService.TransformarFecha(dato);
      } else if (columnasFormatoEspecial[0].tipoDato === 'NUMERO') {
        return this.utilitariosService.TransformarNumerico(dato);
      } else if (columnasFormatoEspecial[0].tipoDato === 'LOGICO') {
        return dato ? 'SI' : 'NO';
      }
    }

    return dato;
  }
  ExportarDirecto() {
    let datosExportar: GenerarConsultasExportarDTO = new GenerarConsultasExportarDTO();
    datosExportar.id = this.parametrosPrincipal.id;
    datosExportar.nombreConsulta = this.parametrosPrincipal.nombreConsulta;
    datosExportar.datos = JSON.stringify(this.listaDatos);

    this.mostrarCargando = true;
    this.generarConsultasService.ExportarDirecto(datosExportar)
              .subscribe((resp: RespuestaGenerica) =>{
                if (resp.procesoExitoso) {
                  this.utilitariosService.AbrirVinculo(resp.mensaje);
                } else {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                }
                this.mostrarCargando = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ExportarConsulta() {
    let datosExportar: GenerarConsultasExportarDTO = new GenerarConsultasExportarDTO();
    datosExportar.id = this.parametrosPrincipal.id;
    datosExportar.nombreConsulta = this.parametrosPrincipal.nombreConsulta;
    datosExportar.listaParametros = this.RetornarValoresParametros();

    this.mostrarCargando = true;
    this.generarConsultasService.ExportarConsultar(datosExportar)
              .subscribe((resp: RespuestaGenerica) =>{
                if (resp.procesoExitoso) {
                  this.utilitariosService.AbrirVinculo(resp.mensaje);
                } else {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                }
                this.mostrarCargando = false;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ValorNumericoVisualizar(): string {
    return `$ ${this.utilitariosService.TransformarNumerico(this.valorTotal.value, 0)}`;
  }
}
